import { useMediaQuery } from "react-responsive";
import { MOBILE_BREAKPOINT_PX } from "@/utils/breakpoints";

// components
import Logo from "@/components/Header/Logo";
import Nav from "@/components/Header/Nav";
import HeroEl from "./HeroEl";
import HeroSubtitle from "./HeroSubtitle";

// styles
import "./Hero.css";
import "@/components/Header/Header.css";

// --------------------------------------------------------------------------------------

export default function Hero() {
	const isMobile = useMediaQuery({
		query: `(max-width: ${MOBILE_BREAKPOINT_PX}px)`,
	});

	return (
		<div className="hero-screen">
			<header className="global-header">
				<Logo />
				{/* Only show Nav in the header on bigger screens */}
				{!isMobile && <Nav />}
			</header>

			<HeroEl />

			{/* On mobile, show Nav here. On bigger screens, show HeroSubtitle */}
			{isMobile ? <Nav /> : <HeroSubtitle />}
		</div>
	);
}
